(function () {
    'use strict';

    angular
        .module('app')
        .controller('BadgeEditController', BadgeEditController);

    BadgeEditController.$inject = ['debug', '$stateParams', 'API', 'helpers', 'i18n', '$q',];

    function BadgeEditController(debug, $stateParams, API, helpers, i18n, $q) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.addSubject = addSubject;
        vm.removeSubject = removeSubject;
        vm.badge = {};
        vm.availableSubjects = [];
        vm.subjects = [];
        vm.loadingState = {
            'badgeIsLoading': false,
            'gameTagsAreLoading': false,
        };

        vm.gameTags = [
            {
                name: 'Loading...',
                label: 'Loading...',
                value: ''
            }
        ];


        vm.now = helpers.getDatabaseDatetime();

        activate();

        function activate() {
            loadBadge();
        }

        function loadBadge() {
            vm.loadingState.badgeIsLoading = true;
            vm.loadingState.gameTagsAreLoading = true;

            var promises = [
                API.Badge.get({ id: vm.id, expand: 'subjects' }).$promise,
                API.Game.get().$promise,
                API.Subject.search({ 'per-page': -1 }).$promise
            ];

            $q.all(promises).then(function(responses){
                vm.badge = responses[0];

                if (responses[1].items.length) {
                    vm.gameTags = [];
                    angular.forEach(responses[1].items, function(game) {
                        vm.gameTags.push({
                            name: game.name,
                            label: game.name,
                            value: game.tag
                        });
                    });
                }

                if(responses[2].items && responses[2].items.length){
                    vm.availableSubjects = responses[2].items;
                }

                if(vm.badge.subjects.length){
                    vm.subjects = vm.badge.subjects;
                } else {
                    addSubject();
                }

                vm.loadingState.badgeIsLoading = false;
                vm.loadingState.gameTagsAreLoading = false;
            }, console.error);
        }

        function addSubject() {
            vm.subjects.push({ id: '' });
        }

        function removeSubject(index){
            vm.subjects.splice(index, 1);
        }

        function save() {
            if (!vm.isSaving) {
                vm.isSaving = true;

                var subjectIds = [];
                angular.forEach(vm.subjects, function(subject){
                    if(parseInt(subject.id, 10) > 0) {
                        subjectIds.push(parseInt(subject.id, 10));
                    }
                });

                if(subjectIds.length){
                    vm.badge.subject_ids = subjectIds;
                }

                var promise = vm.badge.$save({});
                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    vm.now = helpers.getDatabaseDatetime();
                }, function (response) {
                    debug.error(response);
                })
                .finally(function() {
                    vm.isSaving = false;
                });
            }
        }
    }
})();